import { Directive } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { SimpleErrorStateMatcher } from '../../errors/simple-error-matcher';

@Directive({
  standalone: true,
  selector: '[simpleErrorMatcher]',
  providers: [{ provide: ErrorStateMatcher, useClass: SimpleErrorStateMatcher }]
})
export class SimpleErrorMatcherDirective {
  constructor() {}
}
